import React, { Component } from 'react'
import { InfoWindow } from 'react-google-maps'
import { Button } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { setActiveMap } from 'reducers/seaLice/reducer'
import { FILTER_LIST_VIEW } from 'helpers/seaLice'
import messages from '../../translate'

class BarrioInfo extends Component {
  getPosition = locations => {
    const position = {
      lat: null,
      lng: null,
    }

    for (const key in locations) {
      if (locations.hasOwnProperty(key)) {
        const { lat, lng } = locations[key]

        if (position.lat === null) {
          position.lat = lat
          position.lng = lng
          continue
        }

        if (lat > position.lat) {
          position.lat = lat
          position.lng = lng
        }
      }
    }

    return position
  }

  onViewMoreClick = () => {
    this.props.setActiveMap(FILTER_LIST_VIEW)
  }

  render() {
    const {
      barrioInfo,
      onClose,
      intl: { formatMessage },
    } = this.props

    if (!barrioInfo) {
      return null
    }

    return (
      <InfoWindow
        className="site-info-window"
        position={this.getPosition(barrioInfo.polygon)}
        onCloseClick={onClose}
        options={{
          pixelOffset: new window.google.maps.Size(0, 0),
        }}>
        <div>
          <h5>{barrioInfo.name}</h5>
          <h6>
            {`${barrioInfo.label}: ${
              barrioInfo.value || barrioInfo.value === 0
                ? barrioInfo.value
                : 'N/A'
            }`}
          </h6>
          <Button variant="contained" onClick={this.onViewMoreClick}>
            {formatMessage(messages.view_more)}
          </Button>
        </div>
      </InfoWindow>
    )
  }
}

export default connect(null, {
  setActiveMap,
})(injectIntl(BarrioInfo))
